/*
 * @Author: your name
 * @Date: 2021-06-22 15:23:28
 * @LastEditTime: 2021-06-22 19:14:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import tags from './modules/tags'
// import logs from './modules/logs'
import dict from './modules/dict'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './modules/user'
import common from './modules/common'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    // 自己模块的store
    user,
    common,
    // logs,
    tags,
    dict,
  },
  getters,
  strict: process.env.DEV,
})
